import { useQuery } from "react-query";
import axios from "axios";
import { baseUrl } from "./rest_api_config";
import { useState } from "react";

export default function useFetch(name, method, url,refetch , config, actionData) {
  return useQuery(
    [name, url, method, config, actionData],
    async (_, url, method) => {
      switch (method) {
        case "get":
          // console.log("in the get case"); // return async () => {
          const dataGet = await axios.get(`${baseUrl}${url}` , config);
          return dataGet; // };
        case "post":
          const dataPost = await axios.post(
            `${baseUrl}${url}`,
            actionData,
            config
          );
          return { dataPost };
        case "delete":
          const dataDelete = await axios.delete(`${baseUrl}${url}`, config);
          return { dataDelete };
        case "put":
          const dataPut = await axios.put(
            `${baseUrl}${url}`,
            actionData,
            config
          );
          return { dataPut };
        default:
          console.log("API is not defined !");
          break;
      }
    },{
      refetchInterval:refetch>0?refetch:null
    }
  );
}
